import React from 'react';
import styles from '../tayfrassontattoo/tayfrassontattoo.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HallIcon from '../../icons/hallIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Tayfrassontattoo: React.FC = () => {

    return (
        <div className={styles.tayfrassontattoo}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5518997958605?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/tayfrasson.tattoo?igsh=OWhtbGxhZDI0NzZ5"
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            linkInterno={true}
                            href="/tayfrassontattoo/sobremim"
                            title="SOBRE MIM"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tayfrassontattoo;
